import { OrdersContainer } from './views/orders/OrdersContainer'
export default OrdersContainer
